import React, { useState, useEffect } from 'react';
import axiosInstance from './axiosInstance';
import './managecontentstyle/ManageCourse.css';
import ManageModuleProject from './ManageModuleProject';
import EditModule from './EditModule';
import EditLesson from './EditLesson';
import ManageLessonProject from './ManageLessonProject';
import ManageLessonActivities from './ManageLessonActivities';
import ManageLessonPlans from './ManageLessonPlans';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';

const ManageCourse = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [lessons, setLessons] = useState([]);
  
  // New state variables for duplication modals
  const [showModuleDuplicateModal, setShowModuleDuplicateModal] = useState(false);
  const [showLessonDuplicateModal, setShowLessonDuplicateModal] = useState(false);
  const [selectedModuleToDuplicate, setSelectedModuleToDuplicate] = useState(null);
  const [selectedLessonToDuplicate, setSelectedLessonToDuplicate] = useState(null);
  const [targetCourseId, setTargetCourseId] = useState(null);
  const [targetModuleId, setTargetModuleId] = useState(null);

  // Add new state for target course modules
  const [targetCourseModules, setTargetCourseModules] = useState([]);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = () => {
    axiosInstance.post('/api/managecontent/getAllCourses')
      .then(response => {
        const sortedCourses = response.data.slice().sort((a, b) => {
          const coursenameA = a.coursename;
          const coursenameB = b.coursename;
          return coursenameA.localeCompare(coursenameB);
        });

        setCourses(sortedCourses);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleDuplicateCourse = async (courseId) => {
    try {
      const response = await axiosInstance.post('/api/managecontent/duplicateCourse', { courseId });
      if (response.data.success) {
        toast.success('Course duplicated successfully!');
        fetchCourses(); // Refresh the course list
      } else {
        toast.error('Failed to duplicate course');
      }
    } catch (error) {
      console.error('Error duplicating course:', error);
      toast.error('Error duplicating course');
    }
  };

  const handleDuplicateModule = async (moduleId) => {
    setSelectedModuleToDuplicate(moduleId);
    setShowModuleDuplicateModal(true);
  };

  const handleDuplicateLesson = async (lessonId) => {
    setSelectedLessonToDuplicate(lessonId);
    setShowLessonDuplicateModal(true);
  };

  const confirmModuleDuplicate = async () => {
    if (!targetCourseId) {
      toast.error('Please select a target course');
      return;
    }

    try {
      const response = await axiosInstance.post('/api/managecontent/duplicateModule', {
        moduleId: selectedModuleToDuplicate,
        targetCourseId
      });
      
      if (response.data.success) {
        toast.success('Module duplicated successfully!');
        if (selectedCourse) {
          fetchModules(selectedCourse);
        }
      } else {
        toast.error('Failed to duplicate module');
      }
    } catch (error) {
      console.error('Error duplicating module:', error);
      toast.error('Error duplicating module');
    }
    
    setShowModuleDuplicateModal(false);
    setSelectedModuleToDuplicate(null);
    setTargetCourseId(null);
  };

  const fetchTargetCourseModules = async (courseId) => {
    try {
      const response = await axiosInstance.post('/api/managecontent/getAllModule', { courseId });
      const filteredModules = response.data.filter(module => module.Course_id === parseInt(courseId));
      // filteredModules.sort((a, b) => a.ModuleNumber - b.ModuleNumber);
      setTargetCourseModules(filteredModules);
    } catch (error) {
      console.error('Error fetching target course modules:', error);
      toast.error('Error fetching modules for selected course');
    }
  };

  const confirmLessonDuplicate = async () => {
    if (!targetCourseId || !targetModuleId) {
      toast.error('Please select both target course and module');
      return;
    }

    try {
      const response = await axiosInstance.post('/api/managecontent/duplicateLesson', {
        lessonId: selectedLessonToDuplicate,
        targetCourseId,
        targetModuleId
      });
      
      if (response.data.success) {
        toast.success('Lesson duplicated successfully!');
        if (selectedModule) {
          fetchLessons(selectedModule);
        }
      } else {
        toast.error('Failed to duplicate lesson');
      }
    } catch (error) {
      console.error('Error duplicating lesson:', error);
      toast.error('Error duplicating lesson');
    }
    
    setShowLessonDuplicateModal(false);
    setSelectedLessonToDuplicate(null);
    setTargetCourseId(null);
    setTargetModuleId(null);
  };

  const fetchModules = (courseId) => {
    axiosInstance.post('/api/managecontent/getAllModule', { courseId })
      .then(response => {
        const filteredModules = response.data.filter(module => module.Course_id === courseId);
        // filteredModules.sort((a, b) => a.ModuleNumber - b.ModuleNumber);
        setModules(filteredModules);
        setSelectedModule(null);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const fetchLessons = (moduleId) => {
    axiosInstance.post('/api/managecontent/getAllLesson', { moduleId })
      .then(response => {
        const filteredLessons = response.data.filter(lesson => lesson.Module_id === moduleId);
        // filteredLessons.sort((a, b) => a.lessonno - b.lessonno);
        setLessons(filteredLessons);
        setSelectedLesson(null);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleCourseSelect = (courseId) => {
    setSelectedCourse(courseId);
    fetchModules(courseId);
  };

  const handleModuleSelect = (moduleId) => {
    setSelectedModule(moduleId);
    fetchLessons(moduleId);
  };

  const handleLessonSelect = (lessonId) => {
    setSelectedLesson(lessonId);
  };

  useEffect(() => {
    
  }, [selectedLesson]);

  return (
    <div className="manage-course-container">
      <div className="course-list">
        <h6>Courses:</h6>
        {courses.map(course => (
          <div
            key={course.Course_id}
            className={`course-item ${selectedCourse === course.Course_id ? 'selected' : ''}`}
          >
            <div 
              className="course-name"
            onClick={() => handleCourseSelect(course.Course_id)}
          >
            {course.coursename}
            </div>
            <button
              className="copy-button"
              onClick={(e) => {
                e.stopPropagation();
                handleDuplicateCourse(course.Course_id);
              }}
              title="Duplicate Course"
            >
              <FaCopy />
            </button>
          </div>
        ))}
      </div>
      {selectedCourse && (
        <div className="module-list">
          <h6>Modules:</h6>
          {modules.map(module => (
            <div
              key={module.Module_id}
              className={`module-item ${selectedModule === module.Module_id ? 'selected' : ''}`}
            >
              <div 
                className="module-name"
              onClick={() => handleModuleSelect(module.Module_id)}
            >
              {module.modulename}
              </div>
              <button
                className="copy-button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDuplicateModule(module.Module_id);
                }}
                title="Duplicate Module"
              >
                <FaCopy />
              </button>
            </div>
          ))}
        </div>
      )}
      {selectedModule && (
        <div className="lesson-list">
          <h6>Lessons:</h6>
          {lessons.map(lesson => (
            <div
              key={lesson.Lesson_id}
              className={`lesson-item ${selectedLesson === lesson.Lesson_id ? 'selected' : ''}`}
            >
              <div 
                className="lesson-name"
              onClick={() => handleLessonSelect(lesson.Lesson_id)}
            >
              {lesson.lessonname}
              </div>
              <button
                className="copy-button"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDuplicateLesson(lesson.Lesson_id);
                }}
                title="Duplicate Lesson"
              >
                <FaCopy />
              </button>
            </div>
          ))}
        </div>
      )}
       {selectedLesson && (
        <div className="additional-components">
          <EditModule key={`edit-module-${selectedLesson}`} course={selectedCourse} module={selectedModule} />
          <ManageModuleProject key={`manage-module-project-${selectedLesson}`} module={selectedModule} />
          <EditLesson key={`edit-lesson-${selectedLesson}`} lessonid={selectedLesson} />
          <ManageLessonProject key={`manage-lesson-project-${selectedLesson}`} lessonid={selectedLesson} />
          <ManageLessonPlans key={`manage-lesson-plans-${selectedLesson}`} lessonid={selectedLesson} />
          <ManageLessonActivities key={`manage-lesson-activities-${selectedLesson}`} lessonid={selectedLesson} />
        </div>
      )}

      {/* Module Duplication Modal */}
      {showModuleDuplicateModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Duplicate Module</h3>
            <p>Select target course for the duplicated module:</p>
            <select 
              value={targetCourseId || ''} 
              onChange={(e) => setTargetCourseId(e.target.value)}
              className="modal-select"
            >
              <option value="">Select Course</option>
              {courses.map(course => (
                <option key={course.Course_id} value={course.Course_id}>
                  {course.coursename}
                </option>
              ))}
            </select>
            <div className="modal-buttons">
              <button onClick={confirmModuleDuplicate} className="confirm-button">Confirm</button>
              <button onClick={() => setShowModuleDuplicateModal(false)} className="cancel-button">Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Lesson Duplication Modal */}
      {showLessonDuplicateModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Duplicate Lesson</h3>
            <p>Select target course and module for the duplicated lesson:</p>
            <select 
              value={targetCourseId || ''} 
              onChange={(e) => {
                const selectedCourseId = e.target.value;
                setTargetCourseId(selectedCourseId);
                setTargetModuleId(null);
                if (selectedCourseId) {
                  fetchTargetCourseModules(selectedCourseId);
                } else {
                  setTargetCourseModules([]);
                }
              }}
              className="modal-select"
            >
              <option value="">Select Course</option>
              {courses.map(course => (
                <option key={course.Course_id} value={course.Course_id}>
                  {course.coursename}
                </option>
              ))}
            </select>
            {targetCourseId && (
              <select 
                value={targetModuleId || ''} 
                onChange={(e) => setTargetModuleId(e.target.value)}
                className="modal-select"
              >
                <option value="">Select Module</option>
                {targetCourseModules.map(module => (
                  <option key={module.Module_id} value={module.Module_id}>
                    {module.modulename}
                  </option>
                ))}
              </select>
            )}
            <div className="modal-buttons">
              <button onClick={confirmLessonDuplicate} className="confirm-button">Confirm</button>
              <button onClick={() => {
                setShowLessonDuplicateModal(false);
                setTargetCourseModules([]);
              }} className="cancel-button">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageCourse;
